const COLORS = {
  // Service node colors (updated with pastel colors from IMAGE_BG_COLOR_MAP)
  'AWS VPC': '#A690FF',
  'AWS API Gateway': '#FF8FA3',
  ApiGatewayv2: '#FF8FA3',
  'AWS ApiGatewayv2': '#FF8FA3',
  'AWS DynamoDB': '#A690FF',
  'AWS EC2': '#FFB366',
  'AWS ELB': '#A690FF',
  'AWS Glue': '#A690FF',
  'AWS ELBv2': '#A690FF',
  'AWS IAM': '#FF9EC2',
  'AWS KMS': '#FF9EC2',
  'AWS Lambda': '#FFB366',
  'AWS RDS': '#E88EDD',
  'AWS Guardduty': '#FFAA99',
  'AWS S3': '#5CD9B8',
  'AWS SQS': '#E88EBA',
  'AWS SES': '#FF9EC2',
  'AWS.SES.Identities': '#FF9EC2',
  'AWS SNS': '#FF8FA3',
  'AWS EMR': '#A690FF',
  'AWS ECR': '#FFC480',
  'AWS ECS': '#FFC480',
  'AWS Bedrock': '#A8DDD1',
  'AWS ElastiCache': '#8FA3FF',
  'AWS Elastic Beanstalk': '#FFB366',
  'AWS Auto Scaling': '#FF8FA3',
  'AWS Redshift': '#8FA3FF',
  'AWS Route 53': '#A690FF',
  'AWS Route53': '#A690FF',
  'AWS EKS': '#FFC480',
  'AWS EFS': '#A8D96E',
  'AWS Kinesis': '#A690FF',
  'AWS Organizations': '#E88EBA',
  'AWS SageMaker': '#5CD9B8',
  'AWS Step Functions': '#E88EBA',
  'AWS ACM': '#FFAA99',
  'AWS ACMPCA': '#FFAA99',
  'AWS AppSync': '#E88EBA',
  'AWS Athena': '#A690FF',
  'AWS Backup': '#A8D96E',
  'AWS CloudFormation': '#E88EBA',
  'AWS CloudFront': '#C490FF',
  'AWS CloudTrail': '#E88EBA',
  'AWS CloudWatch': '#E88EBA',
  'AWS Cognito': '#FF8FA3',
  'AWS Direct Connect': '#C490FF',
  'AWS Secrets Manager': '#FFAA99',
  'AWS Opensearch': '#A690FF',
  'AWS DocumentDB': '#A690FF',
  'AWS CodeBuild': '#A690FF',
  'AWS DMS': '#8FA3FF',
  NetworkFirewall: '#FFAA99',
  'AWS NetworkFirewall': '#FFAA99',
  'AWS WAF': '#FFAA99',
  'AWS WAFv2': '#FFAA99',
  'AWS SSM': '#E88EBA',
  'AWS Identity Center': '#FF9EC2',
  'AWS Events': '#A8D96E',
  'AWS Fsx': '#A8D96E',
  // Resource node colors (updated with pastel colors matching service colors)
  'AWS.ACM.Certificate': '#FFAA99',
  'AWS.Guardduty.Status': '#FFAA99',
  'AWS.IdentityCenter.Instance': '#FF9EC2',
  'AWS.IdentityCenter.Group': '#FF9EC2',
  'AWS.IdentityCenter.User': '#FF9EC2',
  'AWS.Guardduty.Finding': '#FFAA99',
  'AWS.ACMPCA.CertificateAuthority': '#FFAA99',
  'AWS.ApiGateway.RestApi': '#FF8FA3',
  'AWS.ApiGatewayv2.ApiAccounts': '#FF8FA3',
  'AWS.Athena.QueryExecutions': '#A690FF',
  'AWS.Athena.WorkGroups': '#A690FF',
  'AWS.WAF.WebACL': '#FFAA99',
  'AWS.WAFv2.WebACL': '#FFAA99',
  'AWS.AutoScaling.AutoScalingGroup': '#FF8FA3',
  'AWS.ApiGatewayv2.ApiAccount': '#FF8FA3',
  'AWS.Backup.Plan': '#A8D96E',
  'AWS.Backup.Vault': '#A8D96E',
  'AWS.CloudFormation.Stack': '#E88EBA',
  'AWS.CloudFront.Distribution': '#C490FF',
  'AWS.CodeBuild.BuildProject': '#A690FF',
  'AWS.CloudTrail.Trail': '#E88EBA',
  'AWS.CloudWatch.Alarm': '#E88EBA',
  'AWS.CloudWatchEvents.Rule': '#E88EBA',
  'AWS.CloudWatchLogs.LogGroup': '#E88EBA',
  'AWS.Cognito.UserPool': '#FF8FA3',
  'AWS.DAX.Cluster': '#A690FF',
  'AWS.Direct.Connect.Connections': '#C490FF',
  'AWS.DocDB.Cluster': '#A690FF',
  'AWS.DynamoDB.Table': '#A690FF',
  'AWS.DMS.Endpoint': '#8FA3FF',
  'AWS.DMS.ReplicationTask': '#8FA3FF',
  'AWS.DMS.ReplicationInstance': '#8FA3FF',
  'AWS.EC2.AccountAttributes': '#FFB366',
  'AWS.EC2.Ami': '#FFB366',
  'AWS.EC2.EgressOnlyInternetGateway': '#A690FF',
  'AWS.EC2.EIP': '#FFB366',
  'AWS.EC2.FlowLog': '#A690FF',
  'AWS.EC2.Instance': '#FFB366',
  'AWS.EC2.InternetGateway': '#A690FF',
  'AWS.EC2.KeyPair': '#FFB366',
  'AWS.EC2.NATGateway': '#A690FF',
  'AWS.EC2.NATZones': '#A690FF',
  'AWS.EC2.NetworkACL': '#A690FF',
  'AWS.EC2.NetworkInterface': '#FFB366',
  'AWS.EC2.RouteTable': '#A690FF',
  'AWS.EC2.SecurityGroup': '#FFB366',
  'AWS.EC2.Snapshot': '#FFB366',
  'AWS.EC2.Subnet': '#A690FF',
  'AWS.EC2.Volume': '#FFB366',
  'AWS.EC2.Vpc': '#A690FF',
  'AWS.Bedrock.LoggingConfiguration': '#FFB366',
  'AWS.Bedrock.InferenceProfile': '#FFB366',
  'AWS.Bedrock.Guardrail': '#FFB366',
  'AWS.EC2.VpcEndpoint': '#A690FF',
  'AWS.EC2.VpcPeeringConnection': '#A690FF',
  'AWS.EC2.VPNConnection': '#A690FF',
  'AWS.EC2.VPNGateway': '#A690FF',
  'AWS.ECR.Repository': '#FFC480',
  'AWS.ECR.RepositoryPolicy': '#FFC480',
  'AWS.ECS.Cluster': '#FFC480',
  'AWS.ECS.ContainerInstances': '#FFC480',
  'AWS.ECS.Service': '#FFC480',
  'AWS.EFS.FileSystem': '#A8D96E',
  'AWS.EKS.APIService': '#FFC480',
  'AWS.EKS.Cluster': '#FFC480',
  'AWS.EKS.ClusterRole': '#2875e1',
  'AWS.EKS.ClusterRoleBinding': '#2875e1',
  'AWS.EKS.CustomResourceDefinition': '#2875e1',
  'AWS.EKS.Namespace': '#2875e1',
  'AWS.EKS.PSP': '#2875e1',
  'AWS.EKS.FlowSchema': '#FFC480',
  'AWS.EKS.User': '#FFC480',
  'AWS.EKS.Group': '#FFC480',
  'AWS.EKS.VolumeMetrics': '#A6B1EC',
  'AWS.EKS.CSINode': '#2875e1',
  'AWS.EKS.CNINode': '#2875e1',
  'AWS.EKS.Pod': '#2875e1',
  'AWS.EKS.RoleBinding': '#2875e1',
  'AWS.EKS.ConfigMap': '#2875e1',
  'AWS.EKS.Role': '#2875e1',
  'AWS.EKS.Secret': '#2875e1',
  'AWS.EKS.PriorityClass': '#2875e1',
  'AWS.EKS.PriorityLevelConfiguration': '#2875e1',
  'AWS.EKS.StorageClass': '#2875e1',
  'AWS.EKS.ComponentStatus': '#FFC480',
  'AWS.EKS.ValidatingWebhookConfiguration': '#2875e1',
  'AWS.EKS.MutatingWebhookConfiguration': '#2875e1',
  'AWS.EKS.ControllerRevision': '#2875e1',
  'AWS.EKS.CSIDriver': '#2875e1',
  'AWS.EKS.ServiceAccount': '#2875e1',
  'AWS.EKS.Service': '#2875e1',
  'AWS.EKS.Event': '#2875e1',
  'AWS.EKS.Lease': '#2875e1',
  'AWS.EKS.StatefulSet': '#2875e1',
  'AWS.EKS.Endpoints': '#2875e1',
  'AWS.EKS.EndpointSlice': '#2875e1',
  'AWS.EKS.DaemonSet': '#2875e1',
  'AWS.EKS.NetworkPolicy': '#2875e1',
  'AWS.EKS.Deployment': '#2875e1',
  'AWS.EKS.Node': '#FFC480',
  'AWS.EKS.V_P_C': '#cc6601',
  'AWS.EKS.Container': '#2875e1',
  'AWS.EKS.ReplicaSet': '#2875e1',
  'AWS.EKS.Job': '#FFC480',
  'AWS.EKS.CronJob': '#FFC480',
  'AWS.EKS.Image': '#FFC480',
  'AWS.EKS.PersistentVolumeClaim': '#FFC480',
  'AWS.EKS.PersistentVolume': '#FFC480',
  'AWS.EKS.PodDisruptionBudget': '#FFC480',
  'AWS.EKS.CertificateSigningRequest': '#2875e1',
  'AWS.ElasticBeanstalk.Configuration': '#FFB366',
  'AWS.ElasticBeanstalk.Environment': '#FFB366',
  'AWS.ELB.LoadBalancer': '#A690FF',
  'AWS.ELB.Policy': '#A690FF',
  'AWS.ELBv2.LoadBalancer': '#A690FF',
  'AWS.EMR.Cluster': '#A690FF',
  'AWS.Events.EventBus': '#A8D96E',
  'AWS.ElastiCache.ParameterGroup': '#8FA3FF',

  'AWS.Glue.DataCatalogEncryptionSettings': '#A690FF',
  'AWS.Glue.SecurityConfiguration': '#A690FF',
  'AWS.IAM.AccountPasswordPolicy': '#FF9EC2',
  'AWS.IAM.CredentialReport': '#FF9EC2',
  'AWS.IAM.RootCredentialReport': '#FF9EC2',
  'AWS.IAM.Group': '#FF9EC2',
  'AWS.IAM.Policy': '#FF9EC2',
  'AWS.IAM.Role': '#FF9EC2',
  'AWS.IAM.SAMLProvider': '#FF9EC2',
  'AWS.IAM.ServerCertificate': '#FF9EC2',
  'AWS.IAM.SupportPolicy': '#FF9EC2',
  'AWS.IAM.User': '#FF9EC2',
  'AWS.Kinesis.Stream': '#A690FF',
  'AWS.KMS.Key': '#FF9EC2',
  'AWS.Lambda.Function': '#FFB366',
  'AWS.Logs.MetricFilter': '#E88EBA',
  'AWS.Neptune.DBInstance': '#E88EDD',
  'AWS.Neptune.Dbinstance': '#E88EDD',
  'AWS.Neptune.Snapshot': '#E88EDD',
  'AWS.OpenSearch.Domain': '#A690FF',
  'AWS.Organizations.Organization': '#E88EBA',
  'AWS.Organizations.Account': '#FF9900',
  'AWS.NetworkFirewall.Firewall': '#FFAA99',
  'AWS.NetworkFirewall.FirewallPolicy': '#FFAA99',
  'AWS.NetworkFirewall.FirewallLoggingConfiguration': '#FFAA99',
  'AWS.RDS.Cluster': '#E88EDD',
  'AWS.RDS.EventSubscription': '#E88EDD',
  'AWS.RDS.Event': '#E88EDD',
  'AWS.RDS.Instance': '#E88EDD',
  'AWS.RDS.ReservedInstance': '#E88EDD',
  'AWS.RDS.Snapshot': '#E88EDD',
  'AWS.RDS.DBSubnetGroup': '#E88EDD',
  'AWS.Redshift.Cluster': '#8FA3FF',
  'AWS.Redshift.ParameterGroup': '#8FA3FF',
  'AWS.Route53.Domains': '#A690FF',
  'AWS.Route53.HostedZone': '#A690FF',
  'AWS.S3.Bucket': '#5CD9B8',
  'AWS.NetworkFirewall.FirewallRuleGroup': '#FFAA99',
  'AWS.S3.PublicAccessBlockConfiguration': '#5CD9B8',
  'AWS.Sagemaker.NotebookInstance': '#5CD9B8',
  'AWS.SecretsManager.Secret': '#FFAA99',
  'AWS.Serverless.ApiGateway.RestApi': '#FF8FA3',
  'AWS.Serverless.Lambda.Function': '#FFB366',
  'AWS.Serverless.SFN.StateMachine': '#E88EBA',
  'AWS.SFN.StateMachine': '#E88EBA',
  'AWS.SNS.Topic': '#FF8FA3',
  'AWS.SQS.Queue': '#E88EBA',
  'AWS.IAM.Policystatement': '#FF9EC2',
  'AWS.SSM.Association': '#E88EBA',

  'AWS.EC2.Reservation': '#FFB366',
  'AWS.IAM.Accesskey': '#FF9EC2',
  'Rule.Internet exposed': '#dfdfdf',
  'Identity.Access': '#FF9EC2',
  'Identity.Expose': '#FF9EC2',
  ACMPCA: '#FFAA99',
  AttackPath: '#E88EBA',
  'GCP IAM': '#8FA3FF',
  'GCP Compute Engine': '#8FA3FF',
  'GCP Cloud Storage ': '#B8D4F0',
  'GCP Cloud SQL ': '#B8D4F0',
  'GCP Cloud Functions': '#70D4D4',
  // 'GCP Cloud Storage': '#B8D4F0',
  'GCP KMS': '#6FB8D9',
  'GCP LB ': '#6FB8D9',
  'API Gateway': '#F2B8C6',
  'GCP.GCE.Subnetwork': '#8FA3FF',
  'GCP.GCE.MachineType': '#8FA3FF',
  'GCP Service Usage': '#C490FF',
  'GCP Secret Manager': '#FFA8CC',
  'GCP Cloud Monitoring': '#C490FF',
  'GCP Certificate Manager': '#FFA8CC',
  'GCP.SecretManager.Secret': '#FFA8CC',
  'GCP.CertificateManager.Certificate': '#FFA8CC',
  'GCP.CloudMonitoring.Alert': '#C490FF',
  'GCP CloudCDN': '#C490FF',
  'GCP GKE': '#8FA3FF',
  'GCP Cloud Load Balancing': '#6FB8D9',
  'GCP Load Balancer': '#6FB8D9',
  'GCP Asset Inventory': '#8FA3FF',
  'GCP VPC': '#8FA3FF',
  'GCP Essential Contact': '#8FA3FF',
  'GCP.SU.Services': '#C490FF',
  'GCP.SU.ApiKeys': '#C490FF',
  'GCP.GAR.Repository': '#8FA3FF',
  'GCP.GKE.ApiService': '#FFC480',
  'GCP.GKE.PodMonitoring': '#FFAA99',
  'GCP.GAR.Image': '#8FA3FF',
  'GCP BigQuery': '#D4A5D4',
  'GCP Cloud Logging': '#D4B5F0',
  'GCP Dataproc': '#8FA3FF',
  'GCP Cloud Run': '#8FA3FF',
  'GCP Artifact Registry': '#8FA3FF',
  'GCP Pub/Sub': '#FFA8CC',
  'GCP.Dataproc.Cluster': '#8FA3FF',
  'GCP.CloudRun.Service': '#8FA3FF',
  'GCP.CloudLogging.Log': '#D4B5F0',
  'GCP.BigQuery.Dataset': '#D4A5D4',
  'GCP.PubSub.Topic': '#FFA8CC',
  'GCP.PubSub.Subscription': '#FFA8CC',
  'GCP.CloudFunctions.Function': '#70D4D4',
  'GCP.CloudStorage.Bucket': '#B8D4F0',
  'GCP.CloudSQL.Instance': '#B8D4F0',
  'GCP.IAM.ServiceAccount': '#8FA3FF',
  'GCP.IAM.Role': '#8FA3FF',
  'GCP.KMS.KeyRing': '#6FB8D9',
  'GCP.KMS.CryptoKey': '#6FB8D9',
  'GCP.DNS.Zone': '#A690FF',
  'GCP.DNS.Policy': '#A690FF',
  'GCP.CloudArmor.SecurityPolicy': '#FFAA99',
  'GCP.ASI.Resource': '#8FA3FF',
  'GCP.CLB.LoadBalancer': '#6FB8D9',
  'GCP.CLB.Backend': '#6FB8D9',
  'GCP.CLB.Frontend': '#6FB8D9',
  'GCP.CLO.MetricFilter': '#D4B5F0',
  'GCP.CLO.Sink': '#D4B5F0',
  'GCP.CLO.AuditLog': '#D4B5F0',
  'GCP.CLO.Logging': '#D4B5F0',
  'GCP.GCFv2.Function': '#70D4D4',
  'GCP.GCFv1.Function': '#70D4D4',
  'GCP.CLR.Service': '#8FA3FF',
  'GCP.DPR.Cluster': '#8FA3FF',
  'GCP.SQL.Instance': '#B8D4F0',
  'GCP.STO.Bucket': '#B8D4F0',
  'GCP.STO.Bucket_Label': '#B8D4F0',
  'GCP.PUS.Topic': '#FFA8CC',
  'GCP.PUS.Subscription': '#FFA8CC',
  'GCP.CDN.BackendBucket': '#C490FF',
  'GCP.EC.Contact': '#8FA3FF',
  'GCP.CMS.RedisInstance': '#8FA3FF',
  'GCP.APIGateway.Gateway': '#F2B8C6',

  'Azure Active Directory': '#ddfaff',
  'Azure App Services': '#ddfaff',
  'Azure Network': '#ddfaff',
  'Azure Security Center': '#ddfaff',
  'Azure Storage Accounts': '#ddfaff',
  'Azure Virtual Machines': '#ddfaff',
  'Azure SQL Database': '#ddfaff',
  'Azure Key Vault': '#ddfaff',
  'Azure RBAC': '#ddfaff',
  'Azure Backup Vault': '#ddfaff',
  'Azure Cosmos DB': '#ddfaff',
  'Azure MySQL Database': '#ddfaff',
  'Azure Redis Cache': '#ddfaff',
  'Azure Recovery Services Vault': '#ddfaff',
  'Azure Elastic SAN': '#ddfaff',
  'Azure Database for PostgreSQL': '#ddfaff',
  'Azure Monitor': '#ddfaff',
  'Azure.AAD.User': '#ddfaff',
  'Azure.AAD.Group': '#ddfaff',
  'Azure.AAD.ServicePrincipal': '#ddfaff',
  'Azure.AAD.Application': '#ddfaff',
  'Azure.AppService.WebApp': '#ddfaff',
  'Azure.Network.NetworkSecurityGroup': '#ddfaff',
  'Azure.Network.Watcher': '#ddfaff',
  'Azure.Network.ApplicationSecurityGroup': '#ddfaff',
  'Azure.Network.SecurityGroup': '#ddfaff',
  'Azure.Network.VirtualNetwork': '#ddfaff',
  'Azure.Network.NetworkWatcherFlowLog': '#ddfaff',
  'Azure.Network.ApplicationGateway': '#ddfaff',
  'Azure.Network.NetworkSecurityRule': '#ddfaff',
  'Azure.Network.NetworkInterface': '#ddfaff',
  'Azure.SecurityCenter.AutoProvisioning': '#ddfaff',
  'Azure.SecurityCenter.AutoProvisioningSettings': '#ddfaff',
  'Azure.SecurityCenter.Contact': '#ddfaff',
  'Azure.SecurityCenter.Pricing': '#ddfaff',
  'Azure.Storage.Account': '#ddfaff',
  'Azure.Storage.BlobContainer': '#ddfaff',
  'Azure.Storage.Container': '#ddfaff',
  'Azure.Storage.Queue': '#ddfaff',
  'Azure.Storage.Tables': '#ddfaff',
  'Azure.Storage.AccountNetworkRules': '#ddfaff',
  'Azure.VirtualMachine.Disk': '#ddfaff',
  'Azure.VirtualMachine.Instance': '#ddfaff',
  'Azure.VirtualMachine.Snapshot': '#ddfaff',
  'Azure.VirtualMachine.Image': '#ddfaff',
  'Azure.SQLDatabase.Server': '#ddfaff',
  'Azure.SQLDatabase.Database': '#ddfaff',
  'Azure.KeyVault.Vault': '#ddfaff',
  'Azure.KeyVault.Secret': '#ddfaff',
  'Azure.RBAC.Role': '#ddfaff',
  'Azure.RBAC.RoleAssignments': '#ddfaff',
  'Azure.BackupVault.Vault': '#ddfaff',
  'Azure.CosmosDB.Account': '#ddfaff',
  'Azure.MySQL.Server': '#ddfaff',
  'Azure.Redis.Cache': '#ddfaff',
  'Azure.RecoveryVault.Vault': '#ddfaff',
  'Azure.ElasticSAN.Network': '#ddfaff',
  'Azure.PostgreSQL.Server': '#ddfaff',
  'Azure.Monitor.DiagnosticSetting': '#ddfaff',
  'Azure.Monitor.LogAlert': '#ddfaff',
  'Azure.Monitor.LogProfile': '#ddfaff',
  'Azure.Monitor.ResourceLogging': '#ddfaff',

  Issues: '#CF0000',
  'Rule.Regular': '#F59E0B',
  'Image Push': '#ffcfa7',
  'DockerHub.Repository': '#A8D8FF',
'DockerHub.Image': '#85E0CC',
};

export default COLORS;
